import { Stack } from "@mui/material"
import React from "react"

/** @param {import("@mui/material").StackProps} props */
const HorizontalStackComponent = (props) => {
  return <Stack alignItems="center" flexDirection="row" {...props} />
}

export const HorizontalStack = React.memo(HorizontalStackComponent)
